import React from 'react'
import { FiDownload } from 'react-icons/fi';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { NavLink, useNavigate } from 'react-router-dom';

const Tab = ({ ewayBillChecker, tabList, callBackTab, activeTab, arrowIcon = false, invoiceBillRaiseClass, disabled = false, isCountShow = false, isActiveButton = false, isActiveExport = false, rightButton, tabButtonName, section = "", showAmount = false, keyStatusInsideTabs = false, buttonTitle = "", exportButton = () => { } }) => {

    const navigate = useNavigate();

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        callBackTab(value);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "available":
                return "success";
            case "not_available":
                return "danger";
            case "premium":
                return "warning";
            case "coming_soon":
                return "info";
            default:
                return "secondary";
        }
    };

    const getText = (status) => {
        switch (status) {
            case "available":
                return "";
            case "not_available":
                return "Not Available";
            case "premium":
                return "Premium";
            case "coming_soon":
                return "Coming Soon";
            default:
                return "";
        }
    };

    return (
        <>
            <ul className={`nav nav-tabs cstNew_tabs ${invoiceBillRaiseClass}`} id="addParty" role="tablist">
                {tabList?.map((item, indx) => {
                    const isWebSetting = section === "setting";
                    const key = indx + (item?.title || item?.label);

                    // For setting section, skip items where item.web !== 1
                    if (isWebSetting && item?.web !== 1) return null;

                    const isActive = activeTab === item?.id;

                    return (
                        <li
                            className="nav-item _vhlTab_li"
                            role="presentation"
                            key={key}
                        >
                            {isWebSetting ? (
                                <NavLink
                                    className={({ isActive }) =>
                                        `nav-link tabCst_btn _vhlTab_lst ${isActive ? "active" : ""}`
                                    }
                                    to={item?.link || "#"}
                                    disabled={disabled}
                                >
                                    <span>{item?.label}</span>
                                    {isCountShow && (
                                        <div className="_nwRate">
                                            {item?.data != null ? item.data.toFixed(2) : 0}
                                        </div>
                                    )}
                                    {item?.count !== undefined && (
                                        <span className="_counts">{item.count}</span>
                                    )}
                                    {arrowIcon && (
                                        <div>
                                            <IoChevronForwardOutline />
                                        </div>
                                    )}
                                </NavLink>
                            ) : (
                                <button
                                    className={`nav-link tabCst_btn _vhlTab_lst ${isActive ? "active" : ""}`}
                                    type="button"
                                    aria-selected={isActive}
                                    onClick={(e) => changeActiveTab(e, item?.id)}
                                    disabled={disabled || item?.disabled}
                                >
                                    {!ewayBillChecker ?
                                        <span className='__mnLab_title'>
                                            {item?.title}
                                            {(keyStatusInsideTabs && item?.key) ?
                                                <span className={`badge bg-${getStatusColor(item?.key)} keySpan_cls`}>
                                                    {getText(item?.key)}
                                                </span>
                                                :
                                                <></>}
                                        </span>
                                        :
                                        <></>
                                    }
                                    {isCountShow && (
                                        <div className="_nwRate" style={{color: '#06f', position: 'relative', top: '-2px'}}>
                                            {item?.data != null ? item.data.toFixed(2) : 0}
                                        </div>
                                    )}
                                    {item?.count !== undefined && (
                                        <span className="_counts">{item.count}</span>
                                    )}
                                    {showAmount ? <span className='__mnLab_amount'> Amount &#x20B9; {item?.amount}</span> : <></>}
                                    {ewayBillChecker ? <span className='mt-1'>{item?.title}</span> : <></>}
                                    {arrowIcon && (
                                        <div>
                                            <IoChevronForwardOutline />
                                        </div>
                                    )}
                                </button>
                            )}
                        </li>
                    );
                })}

               { (isActiveExport || isActiveButton) && <div className='_rSideBtn' style={{ marginLeft: 'auto' }}>
                    {isActiveExport ?
                        <button className='anime-btn __exptBtn' style={{marginRight:'8px'}} onClick={(e) => exportButton(e)}>  <FiDownload /> {buttonTitle}</button>
                        : <></>}
                    {isActiveButton ? <button className='_addComm_btn' onClick={(e) => rightButton(e)}> {tabButtonName}</button> : <></>}
                </div>}

            </ul>
        </>
    )
}

export default Tab